import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SelectedCampaignVM } from 'features/src/lib/donations/types/campaigns.models';
import { parseCampaignDetail } from './campaign-detail.parser';

@Component({
  selector: 'don-campaign-detail-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './campaign-detail-modal.component.html',
  styleUrls: ['./campaign-detail-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignDetailModalComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) campaign: SelectedCampaignVM | null = null;
  @Input() isOpen = false;
  @Output() close = new EventEmitter<void>();

  constructor(public translate: TranslateService) {}

  get name(): string {
    if (!this.campaign) return this.translate.instant('CAMPAIGN.BrandAlt');
    return this.isSpanish ? this.campaign.nameEs : this.campaign.nameEn;
  }

  get description(): string {
    if (!this.campaign) return '';
    return this.isSpanish ? this.campaign.descriptionEs : this.campaign.descriptionEn;
  }

  get detailTagline(): string {
    return this.parseCampaignDetail().tagline;
  }

  get detailBody(): string {
    return this.parseCampaignDetail().body;
  }

  get detailActions(): Array<{ label: string; text: string }> {
    return this.parseCampaignDetail().actions;
  }

  get detailListIntro(): string {
    return this.parseCampaignDetail().listIntro;
  }

  get detailSignOff(): string {
    return this.parseCampaignDetail().signOff;
  }

  closeModal(): void {
    this.close.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      if (this.isOpen) {
        document.body.classList.add('has-campaign-modal-open');
      } else {
        document.body.classList.remove('has-campaign-modal-open');
      }
    }
  }

  ngOnDestroy(): void {
    document.body.classList.remove('has-campaign-modal-open');
  }

  private parseCampaignDetail() {
    return parseCampaignDetail(this.description ?? '');
  }

  private get isSpanish(): boolean {
    const locale = (this.translate.currentLang || this.translate.getDefaultLang() || 'en').toLowerCase();
    return locale.startsWith('es');
  }
}
